/**
 * Class for tracking the usage of keyboard by user
 * Can be used to tell which keys are pressed
 * @class KeyboardTracker
 */
class KeyboardTracker {
  constructor() {
    this._initialized = false;

    this.pressed = new Set();

    // Bind `this` to all event listeners
    this.keydown = this._keydown.bind(this);
    this.keyup = this._keyup.bind(this);

    /** Unix timestamp of last event trigger */
    this.lastChange = null;
  }

  /**
   * Returns `true` if `key` is pressed; `false` otherwise
   * @param {String} key
   */
  isPressed(key) {
    return this.pressed.has(key);
  }

  /**
   * Bound to onkeydown
   * @param {KeyboardEvent} e
   */
  _keydown(e) {
    this.pressed.add(e.key);
    this.lastChange = Date.now();
  }

  /**
   * Bound to onkeyup
   * @param {KeyboardEvent}
   */
  _keyup(e) {
    this.pressed.delete(e.key);
    this.lastChange = Date.now();
  }

  /**
   * Removes all event listeners
   */
  kill() {
    if (this._initialized) {
      window.removeEventListener('keydown', this.keydown);
      window.removeEventListener('keyup', this.keyup);
    }
  }

  /**
   * Initiates all event listeners
   */
  init() {
    if (!this._initialized) {
      window.addEventListener('keydown', this.keydown);
      window.addEventListener('keyup', this.keyup);

      this._initialized = true;
    }
  }
}

export default KeyboardTracker;
